import axios from 'axios';

const { get } = axios;

export const getDatasets = () => get('/v1/dataviewer/datasets/');

export const getDataset = (category, slug, filters = {}) =>
  get(`/v1/dataviewer/datasets/${category}/${slug}/`, { params: filters });
